import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./CertificateGallery.css";

const CertificateGallerySkeleton = () => {
  return (
    <div className="gallery-container">
      <div className="slider">
        {[...Array(1)].map((_, index) => (
          <div key={index} className="slide" style={{ width: "50%",justifyContent:"center",margin:"auto" }}>
            <Skeleton
              height={200}
              borderRadius={10}
              style={{ minHeight: 200, maxHeight: 200, objectFit: "contain" }}
            />
            <Skeleton height={20} width="60%" />
          </div>
        ))}
      </div>

      {/* Grid Skeleton with exact responsive columns and spacing */}
      <div className="grid-gallery" style={{ marginTop: "2rem" }}>
        {[...Array(10)].map((_, index) => (
          <div
            key={index}
            className="grid-item"
            style={{ height: 150, width: "100%", borderRadius: 8 }}
          >
            <Skeleton
              height={150}
              borderRadius={8}
              style={{ objectFit: "contain" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CertificateGallerySkeleton;
